import { render, staticRenderFns } from "./StatSectionNewsList.vue?vue&type=template&id=3a15874c&scoped=true&"
import script from "./StatSectionNewsList.vue?vue&type=script&lang=js&"
export * from "./StatSectionNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15874c",
  null
  
)

export default component.exports